// legal-documentation.component.ts
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-legal-documentation',
  templateUrl: './legal-documentation.component.html',
  styleUrls: ['./legal-documentation.component.scss'],
})
export class LegalDocumentationComponent implements OnInit {
  activeButton: string = '';

  constructor(private router: Router) {}

  ngOnInit(): void {
  }

  setActiveButton(button: string) {
    this.activeButton = button;
  }
}
